export default "__VITE_ASSET__CZiqc5C2__"